(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('FrequentlyAskedQuestionStateHistory', FrequentlyAskedQuestionStateHistory);

    FrequentlyAskedQuestionStateHistory.$inject = ['$resource', 'DateUtils'];

    function FrequentlyAskedQuestionStateHistory ($resource, DateUtils) {
        var resourceUrl =  'api/frequently-asked-question-state-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.stateSetTimestamp = DateUtils.convertDateTimeFromServer(data.stateSetTimestamp);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
